<div class="main-container">
    
    <div class="table-actions" *ngIf="!readonly">
        <button
            type="button"
            class="manage-service-button tertiary_button"
            (click)="configureServices()"
        >
            <app-svg-icon
            class="image-icon"
            [path]="'assets/icons/add_plus_icon.svg'"
            ></app-svg-icon>
            <span>Add Services</span>
        </button>
    </div>

    <app-static-table
    [tableMeta]="serviceTableMeta"
    [(data)]="serviceList"
    [showCheckBox]="false"
    [deleteAllowed]="false"
    [readOnlyMode]="readonly"
    [noDataFoundMsg]="'No service added'"
    (dataChange)="onServiceListChange($event)"
    (rowActionTriggered)="handleRowAction($event)"
    >
    </app-static-table>
</div>